import classNames from 'classnames';
import React, { FC, ReactElement, ReactNode, SyntheticEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { UiButton } from 'src/components/UI/Button';
import { ChildrenPropType } from 'src/utils/types';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { getOtherThanBaseDomainFromUrl, isDomainInTheLinkTheSameAsTheApp } from 'src/utils/url';
import styles from './styles.module.scss';

type Props = {
  children: ChildrenPropType | string;

  onClick?: (e: SyntheticEvent<HTMLButtonElement | HTMLLinkElement>) => void;
  active?: boolean;
  icon?: string;
  title?: string;
  href?: string;
  materialIcon?: string;
  className?: string;
  buttonClassName?: string;
  postFix?: ReactNode;
  outerLink?: boolean;
  spaLink?: boolean;
  tryMakeSPALink?: boolean;
  withDisabledBtn?: boolean;
  loading?: boolean;
};

export const CustomDropdownListElement: FC<Props> = ({
  active = true,
  onClick,
  children,
  icon,
  title,
  href,
  materialIcon,
  className,
  buttonClassName,
  postFix,
  outerLink,
  spaLink,
  tryMakeSPALink = false,
  withDisabledBtn,
  loading,
}): ReactElement => {
  const content = (
    <>
      {(!!materialIcon && <i className="material-icons">{materialIcon}</i>) || (!!icon && <i className={icon} />)}
      {children}
    </>
  );

  /** prepare a correct link and make it SPA inner link */
  if (tryMakeSPALink && href) {
    if (isDomainInTheLinkTheSameAsTheApp(href)) {
      spaLink = true;
      href = getOtherThanBaseDomainFromUrl(href);
    }
  }

  const Link = outerLink ? UiOuterLink : UiInnerNotSPALink;

  return (
    <li className={classNames(className, { disabled: !active })}>
      {href && active ? (
        <>{spaLink ? <RouterLink to={href}>{content}</RouterLink> : <Link href={href}>{content}</Link>}</>
      ) : (
        <UiButton
          tag="a"
          onClick={active ? onClick : undefined}
          title={title}
          className={classNames(styles.btn, buttonClassName)}
          disabled={!active && withDisabledBtn}
          loading={loading}
        >
          {content}
        </UiButton>
      )}
      {postFix}
    </li>
  );
};
